<template>
  <v-row class="fill-height justify-center">
    <v-col cols="12" xl="8">
      <v-app-bar color="blue-grey lighten-2" id="app-bar-manage" dense dark flat>
        <v-toolbar-title>Manage E-Paper</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="logged-user">
          logged in as:
          <span>{{user.data.email}}</span>
        </div>

        <template v-if="user.loggedIn">
          <v-btn icon @click.prevent="signOut">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>

        <template v-else>
          <v-btn icon @click.prevent="signOut">
            <router-link to="auth" class="nav-link">
              <v-icon>mdi-login</v-icon>
            </router-link>
          </v-btn>
        </template>
      </v-app-bar>

      <!-- <h1 class="heading">Manage E-Paper</h1> -->
      <v-sheet height="64">
        <v-toolbar flat color="white" class="calendar-toolbar">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              color="primary"
              class="mr-4"
              :elevation="hover ? 12 : 2"
              @click="dialog = true"
            >Upload new paper</v-btn>
          </v-hover>

          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">Today</v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" class="mr-4" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <v-dialog v-model="dialog" max-width="35rem">
        <v-card class="mx-auto dialog-add-paper" outlined>
          <v-form @submit.prevent="addPaper">
            <v-list-item three-line>
              <v-col class="thumb-col">
                <v-list-item-avatar tile color="grey lighten-3">
                  <v-btn
                    color="blue-grey"
                    class="ma-2 white--text"
                    fab
                    :disabled="date == '' || date == null || isValidDate == false ? true : false"
                    :loading="pdfUploading"
                  >
                    <v-icon dark>mdi-paperclip</v-icon>
                  </v-btn>
                  <v-file-input
                    label
                    accept=".pdf"
                    id="epaper-upload"
                    loading="true"
                    :disabled="date == '' || date == null || isValidDate == false ? true : false"
                    @change="remoteUploadPaper"
                    v-model="file"
                  ></v-file-input>
                  <div class="upload-status upload-paper" v-if="pdfUploading">Uploading paper</div>
                  <canvas id="pdfCanvas" :class="file ? '' : 'd-none'"></canvas>
                </v-list-item-avatar>
              </v-col>
              <v-col>
                <v-list-item-content>
                  <div class="overline mb-4">Add new epaper</div>
                  <v-list-item-title class="headline mb-1">
                    Epaper:
                    <span v-if="date != ''">{{ date }}</span>
                    <span v-else>--/--/--</span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-if="isValidDate"
                  >Please select the date before uploading a newspaper</v-list-item-subtitle>
                  <v-alert
                    type="error"
                    v-else
                    style="margin: 0;"
                    class="pdf-alert"
                  >An E-paper has already existed for the date you've selected. Please select a different date or delete the existing e-paper first</v-alert>
                </v-list-item-content>

                <v-spacer style="height: 1rem;"></v-spacer>
                <v-text-field v-model="date" type="date" label="Paper Date (required)"></v-text-field>
                <v-select
                  :items="statusOptions"
                  label="Status"
                  v-model="status"
                  :disabled="date == '' || date == null ? true : false"
                ></v-select>

                <v-card-actions class="justify-end" style="padding-right: 0">
                  <v-btn text @click="dialog = false" color="grey">Close</v-btn>
                  <v-btn
                    type="submit"
                    color="primary"
                    class="ml-6"
                    @click.stop="dialog = false"
                    :disabled="submitDisabled"
                  >Add Paper</v-btn>
                </v-card-actions>
              </v-col>
            </v-list-item>
          </v-form>
        </v-card>
      </v-dialog>

      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :type="type"
          :events="papers"
          :event-color="getStatusColor"
          @click:event="showPaper"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          scale
        >
          <v-card color="grey lighten-4" flat id="view-paper-card">
            <v-toolbar :color="selectedPaper.color" dark>
              <v-btn @click="deletePaper(selectedPaper.id)" icon>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedPaper.name"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-list-item three-line id="view-selected-paper">
                <v-col class="thumb-col">
                  <v-list-item-avatar tile color="grey lighten-3">
                    <img :src="thumbUrl" id="paper-thumb" alt="no preview available" />
                  </v-list-item-avatar>
                </v-col>
                <v-col class="info-col">
                  <v-list-item-content class="info-header">
                    <div class="overline mb-4">{{selectedPaper.name}}</div>
                  </v-list-item-content>

                  <v-list disabled dense two-line flat>
                    <v-list-item-group>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Filename:</v-list-item-title>
                          <v-list-item-subtitle v-html="selectedPaper.filename"></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Added By:</v-list-item-title>
                          <v-list-item-subtitle>
                            <span v-html="selectedPaper.added_by"></span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Status:</v-list-item-title>
                          <v-list-item-subtitle v-html="selectedPaper.status"></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-list-item>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="secondary" @click="selectedOpen = false">Close</v-btn>
              <!-- <v-btn
                text
                v-if="currentlyEditing !== selectedPaper.id"
                @click.prevent="editPaper(selectedPaper)"
              >Edit</v-btn>
              <v-btn text v-else @click.prevent="updatePaper(selectedPaper)">Save</v-btn>-->
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>


<script>
import { db } from "@/main";
import { mapGetters } from "vuex";
import axios from "axios";
import firebase from "firebase";
import pdfjsLib from "pdfjs-dist/webpack.js";

export default {
  name: "Manage",
  data: () => ({
    toady: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
    },
    //---
    added_by: null,
    date: null,
    status: null,
    thumbnail: null,
    destination: null,
    filename: null,
    path: null,
    file: null,
    //---
    statusOptions: ["Unpublished", "Published"],
    pdfUploading: false,
    currentlyEditing: null,
    selectedPaper: {},
    selectedElement: null,
    selectedOpen: false,
    papers: [],
    dialog: false,
    isValidDate: true,
  }),
  computed: {
    ...mapGetters({
      user: "user",
    }),
    submitDisabled: function () {
      if (!this.date || !this.status || !this.filename || !this.isValidDate) {
        return true;
      } else {
        return false;
      }
    },
    thumbUrl: function () {
      let url = this.selectedPaper.thumbnail;
      return url;
    },
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.getPapers();
    this.updateUser();
  },
  watch: {
    date: function (d) {
      this.checkPaperDate(d);
    },
  },
  methods: {
    async getPapers() {
      let snapshot = await db.collection("epaper").get();
      let papers = [];

      snapshot.forEach((doc) => {
        let appData = doc.data();
        let dateFormatted = this.$moment(doc.data().date.toDate())
          .format()
          .substr(0, 10);
        appData.id = doc.id;
        appData.start = dateFormatted;
        appData.end = dateFormatted;
        appData.name = `E-Paper ${dateFormatted}`;
        appData.timed = false;
        appData.color = this.assignStatusColor(doc.data().status);
        papers.push(appData);
        // console.log(appData);
      });
      this.papers = papers;
    },
    async addPaper() {
      if (this.date && this.status && this.filename) {
        await db.collection("epaper").add({
          added_by: this.added_by,
          date: new Date(this.date),
          paper_date: this.date,
          status: this.status,
          thumbnail: this.thumbnail,
          destination: this.destination,
          filename: this.filename,
          path: this.path,
          created_on: new Date(),
        });
        this.getPapers();

        this.added_by = null;
        this.date = null;
        this.status = null;
        this.thumbnail = null;
        this.destination = null;
        this.filename = null;
        this.path = null;
        this.file = null;
      }
    },
    async updatePaper(p) {
      await db.collection("epaper").doc(this.currentlyEditing).update({
        status: p.status,
      });
      this.selectedOpen = false;
      this.currentlyEditing = null;
      this.getPapers();
    },
    async deletePaper(p) {
      await db.collection("epaper").doc(p).delete();
      this.selectedOpen = false;
      this.getPapers();
    },
    async remoteUploadPaper(p) {
      if (p) {
        this.pdfUploading = true;
        this.generateThumbnail();

        let formData = new FormData();
        formData.append("year", this.$moment(this.date).format("YYYY"));
        formData.append("month", this.$moment(this.date).format("MM"));
        formData.append("date", this.$moment(this.date).format("DD"));
        formData.append("epaper", p);

        await axios
          .post(`${this.apibase}/island/api/uploadpaper`, formData)
          .then((response) => {
            this.destination = response.data.destination;
            this.filename = response.data.filename;
            this.path = response.data.path;
            this.pdfUploading = false;
          })
          .catch((e) => {
            //this.errors.push(e);
            console.log(e);
          });
      }
    },
    async checkPaperDate(date) {
      var self = this;
      db.collection("epaper")
        .where("paper_date", "==", this.$moment(date).format().substr(0, 10))
        .get()
        .then(function (querySnapshot) {
          if (!querySnapshot.empty) {
            self.isValidDate = false;
          } else {
            self.isValidDate = true;
          }
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    assignStatusColor(s) {
      let statusColor;
      switch (s) {
        case "Published":
          statusColor = "green";
          break;
        case "Unpublished":
          statusColor = "deep-orange";
          break;
        case "Scheduled":
          statusColor = "cyan";
          break;
        default:
          statusColor = "grey";
          break;
      }
      return statusColor;
    },
    getStatusColor(p) {
      return p.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    editPaper(p) {
      this.currentlyEditing = p.id;
    },
    showPaper({ nativeEvent, event }) {
      const open = () => {
        this.selectedPaper = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };
      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({
            name: "Home",
          });
        });
    },
    updateUser() {
      this.added_by = this.user.data.email;
    },
    generateThumbnail() {
      var file = event.target.files[0];
      var fileReader = new FileReader();
      var self = this;

      fileReader.onload = function () {
        var typedarray = new Uint8Array(this.result);
        //console.log(typedarray);

        const loadingTask = pdfjsLib.getDocument(typedarray);
        loadingTask.promise.then((pdf) => {
          pdf.getPage(1).then(function (page) {
            //console.log("Page loaded");

            var scale = 0.25;
            var viewport = page.getViewport({
              scale: scale,
            });

            var canvas = document.getElementById("pdfCanvas");
            var context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            var renderContext = {
              canvasContext: context,
              viewport: viewport,
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
              //console.log("Page rendered");
              self.thumbnail = canvas.toDataURL();
              //console.log(self.thumbnail.length);
            });
          });
        });
      };
      fileReader.readAsArrayBuffer(file);
    },
  },
};
</script>

<style lang="scss" scoped>
#app-bar-manage {
  border-radius: 0.25rem;
  margin-bottom: 3rem;

  .logged-user {
    font-size: 0.85rem;
    font-style: normal;
    margin-right: 1rem;

    span {
      font-weight: 600;
    }
  }
}

.heading {
  margin-bottom: 0.5rem;
}

.v-toolbar.calendar-toolbar {
  &::v-deep .v-toolbar__content {
    padding-left: 0;
    padding-right: 0;
  }
}

.dialog-add-paper {
  &::v-deep .thumb-col {
    .v-avatar {
      height: 21rem !important;
      width: 95% !important;
      display: flex;
      flex-direction: column;
      align-items: center;

      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: -12.5%;
        right: 0;
        background: #fff;
        z-index: 1;
        opacity: 1;
        width: 125%;
        height: 0;
        margin: auto;
        padding-bottom: 125%;
        border-radius: 50%;
        filter: blur(3rem);
        pointer-events: none;
      }

      .v-btn {
        position: absolute;
        z-index: 5;
      }

      .v-input {
        position: absolute;
        transform: translateY(3rem);
        z-index: 5;

        .v-input__prepend-outer {
          position: absolute;
          left: 0;
          right: 0;
          margin: 0 auto;
          top: -2rem;

          .v-icon {
            width: 4rem;
            height: 4rem;
            display: block;
            border-radius: 50%;
            opacity: 0;
          }
        }

        .v-input__control {
          margin-left: 24px;
          font-size: 0.85rem;
        }
      }
    }
  }
}

.v-calendar {
  &::v-deep .v-event {
    height: 100% !important;
    position: absolute;
    top: 0;
    z-index: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    margin-bottom: auto;
    text-align: center;
    padding-top: 60px;
  }

  &::v-deep .v-calendar-weekly__day-label {
    z-index: 1;
    position: relative;
  }
}

#pdfCanvas {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
}

.pdf-alert {
  font-size: 0.875rem;
}

.upload-status {
  position: absolute;
  bottom: 3rem;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.1rem;
  color: #6a6565;
  animation: blinker 1s linear infinite;
  z-index: 5;
  background: #607d8b;
  color: #fff;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

#view-selected-paper {
  padding: 0;
  align-items: stretch;

  .thumb-col {
    .v-avatar {
      margin: 0;
      width: 95% !important;
      height: 125% !important;
      position: relative;

      #paper-thumb {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        margin: auto;
        max-height: 100%;
        width: auto;
        right: 0;
        bottom: 0;
      }
    }
  }

  .info-col {
    margin-bottom: -1rem;

    .info-header {
      padding: 0;
    }

    .v-list {
      background: transparent;
      padding: 0;

      .v-item-group {
        .v-list-item {
          padding-left: 0;
        }
      }
    }
  }
}

#view-paper-card {
  min-width: 32.5rem;
}
</style>